import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Polices auto-hébergées (§9.2) : deux fichiers variables, comme sur la vitrine.
// L'arabe est chargé à la demande, uniquement si l'interface passe en arabe.
import '@fontsource-variable/bricolage-grotesque/wdth.css';
import '@fontsource-variable/public-sans';
import '@ef2c/tokens/tokens.css';
import '@ef2c/tokens/base.css';
import './styles/app.css';
import { App } from './App.js';

const racine = document.getElementById('racine');
if (!racine) throw new Error('élément racine introuvable dans index.html');

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
